// Environment helpers driven by the build-time REACT_APP_ENVIRONMENT variable.
// The Azure DevOps pipeline (UI/azure-pipeline.yml) writes this from the
// $(ENVIRONMENT) Library variable. The prodvariables group sets it to "Prod";
// the testvariables group (and local dev) should leave it unset or set to a
// non-"Prod" value. We intentionally default to non-prod when unset so that
// local Docker development behaves like testing without any .env edits.

export const getAppEnvironment = () =>
  (process.env.REACT_APP_ENVIRONMENT || "").trim();

export const APP_ENVIRONMENT = getAppEnvironment();

export const isProductionEnvironment = () => getAppEnvironment() === "Prod";

export const isNonProductionEnvironment = () => !isProductionEnvironment();
